import { appVersion } from '@/common/device-info';
import { isAndroid } from '@kibt/krn-utils';
import { versionCompare } from '@kibt/web-utils/version';
// 容器高度支持配置 AB实验 https://abtest-sgp.corp.kuaishou.com/ab2#/experiment/analysis/6770/detail?tab=2&docType=12&isShared=true

// 容器高度和弹窗高度的实验已结束，ios返回0.75，安卓版本>9940时返回0.75，否则返回0.8
export const getAbHeight = () => {
    if (isAndroid && versionCompare(appVersion, '9.9.40') === -1) return 0.8;
    else return 0.75;
};
